var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
      _vm.entry.id &&
        _vm.entry.weekdays &&
        !(_vm.isUsingDefaultWeekdays && _vm.hideDefaultWeekdays)
    )?_c('div',[_c('small',{staticClass:"msr--text nowrap"},[_vm._v(_vm._s(_vm.description))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/EntryWeekdays.vue?vue&type=template&id=3721eaf4&
// module id = 2266
// module chunks = 5